import { render, staticRenderFns } from "./bi_scatter.vue?vue&type=template&id=479370cd&scoped=true"
import script from "./bi_scatter.vue?vue&type=script&lang=js"
export * from "./bi_scatter.vue?vue&type=script&lang=js"
import style0 from "./bi_scatter.vue?vue&type=style&index=0&id=479370cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479370cd",
  null
  
)

export default component.exports